import Box from '@mui/material/Box';
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import Select from '@mui/material/Select';
import { OutlinedInput } from '@mui/material';

export default function BasicSelect({ lineId, setLineId }) {
  const handleChange = (event) => {
    setLineId(event.target.value);
  };

  return (
    <Box sx={{ minWidth: 120 }}>
      <FormControl size='medium'>
        <InputLabel id='demo-simple-select-label'>Select Route</InputLabel>
        <Select
          labelId='demo-simple-select-label'
          id='demo-simple-select'
          value={lineId}
          label='Route'
          input={<OutlinedInput notched label={'Select Route'} />}
          onChange={handleChange}
        >
          <MenuItem value={'07'}>ΠΑΝΕΠΙΣΤΗΜΙΟΥΠΟΛΗ</MenuItem>
          <MenuItem value={'02'}>ΚΙΜΜΕΡΙΑ</MenuItem>
          <MenuItem value={'11'}>ΚΙΜΜΕΡΙΑ - ΠΗΓΑΔΙΑ</MenuItem>
        </Select>
      </FormControl>
    </Box>
  );
}
